import { Children, ReactNode, useContext } from 'react';
import tableContext from './tableContext';

type Props = {
    children: ReactNode;
};

const TableRowContainer: React.FC<Props> = ({ children }) => {
    const { curPage, rowPerPage, pagination, dataLength } = useContext(tableContext);

    if (!children) {
        throw new Error('TableRowContainer must contain at least 1 children');
    }

    return (
        <>
            {pagination && dataLength
                ? Children.toArray(children).slice(
                      (curPage - 1) * rowPerPage,
                      curPage * rowPerPage
                  )
                : children}
        </>
    );
};

TableRowContainer.displayName = 'TableRowContainer';

export default TableRowContainer;
